import Vue from 'vue'
import translateError from './translate-error'
Vue.prototype.translateError = translateError
